<template>
  <el-container>

    <el-row :gutter="10">
      <el-col :span="24">
          <el-row :gutter="10">
            <el-col :span="20">
    
              <el-form :inline="true" :model="formInline" class="demo-form-inline" size="mini">
                <el-form-item>
                  <el-button type="primary" icon="el-icon-edit" @click="openPatrolCardForm(0)">录入</el-button>
                </el-form-item>
                <el-form-item>
                  <el-input v-model="selectedHoldName" placeholder="请选择" style="width:166px;"></el-input>
                  <el-button type="default" icon="el-icon-folder-opened" @click="openLayer">打开组织树</el-button>
                  <div v-if="isVisible" class="floating-layer">
                    <div class="layer-content">
                      <!-- 浮动层内容 -->
                      <div class="tree-divBox">
                        <el-tree 
                          :data="holdTreeData" 
                          :props="defaultProps" 
                          default-expand-all 
                          ref="getTreeInstance" 
                          @node-click="handleNodeClick"></el-tree>
                      </div>
                      <el-button type="info" size="mini" icon="el-icon-close" @click="closeLayer" circle></el-button>
                    </div>
                    <!-- <div class="overlay" @click="closeLayer"></div> -->
                  </div>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="formInline.search_type" placeholder="选择搜索类别" style="width:120px;">
                    <el-option
                      v-for="item in search_type_options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input v-model="formInline.key" placeholder="关键词"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="success" icon="el-icon-search" @click="SearchPatrolCardList()">查询</el-button>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="4">
              <el-form :inline="true" class="demo-form-inline" size="mini" style="text-align: right;">
                
              </el-form>
            </el-col>
          </el-row>
          
          <div>
              <el-table
                id="tbGridView"
                ref="getTableInstance"
                :data="tableData"
                :height="tableViewHeight"
                v-loading="loadingTableData"
                size="small"
                stripe
                style="width: 100%">
                <el-table-column
                  prop="number"
                  label="序号"
                  width="50">
                </el-table-column>
                <el-table-column
                  prop="patrol_sn"
                  label="卡编号"
                  width="150">
                </el-table-column>
                <el-table-column
                  prop="patrol_name"
                  label="巡检点名称"
                  width="150">
                </el-table-column>
                <el-table-column
                  prop="hold_name"
                  label="所属组织"
                  width="200">
                </el-table-column>
                <el-table-column
                  prop="location"
                  label="位置"
                  width="200">
                </el-table-column>
                <el-table-column
                  prop="remark"
                  label="备注">
                </el-table-column>
                <el-table-column
                  prop="create_time"
                  label="录入时间"
                  width="200">
                </el-table-column>
                <el-table-column
                  prop="operator"
                  label="操作"
                  width="200">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      @click="openPatrolCardForm(scope.row.patrol_id)">编辑</el-button>
                    <el-button
                      size="mini"
                      type="danger"
                      @click="removePatrolCard(scope.row.patrol_id)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
          </div>

          <div class="dv-pagging-container">
            <el-pagination
              background
              layout="prev, pager, next"
              :page-size="pagging.pager_size"
              :pager-count="pagging.pager_count"
              :total="pagging.records_total"
              :current-page="pagging.current_page">
            </el-pagination>
          </div>
      </el-col>
    </el-row>

    <PatrolCardForm ref="patrolCardForm" @eventRefreshTableName="SearchPatrolCardList" />

  </el-container>
</template>

<script>
import Api from '../../api/index'
import PatrolCardForm from './PatrolCardFormView.vue'

export default {
  name: 'patrolcard_manage',
  components: {
    PatrolCardForm
  },
  data() {
    return {
      isVisible: false, // 控制浮动层是否显示
      dialogFormVisible: false,
      currentTabsNodeName: "staff-department",
      selectedHoldName: "",
      formInline: {
        key: '',
        search_type: 'patrol_sn',
      },
      search_type_options: [
          {
            value: 'patrol_sn',
            label: '卡编号'
          },{
            value: 'patrol_name',
            label: '巡检点名称'
          },{
            value: 'location',
            label: '位置'
          }
      ],
      tableViewHeight: 600,
      loadingTableData: false,
      selectHoldId: 0,
      holdTreeData: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      tableData: [],
      pagging: {
        records_total: 0,
        pager_count: 5,
        pager_size: 25,
        current_page: 1
      }
    }
  },
  methods: {
    openLayer() {
      this.isVisible = true;
    },
    closeLayer() {
      this.isVisible = false;
    },
    loadHoldTree: function(){
      Api.GetHoldTree({}).then(res => {
        if(!res)
          return;
        this.holdTreeData = res.data;
        // 初始化选中的用户id
        this.selectHoldId = this.holdTreeData[0].id;
        this.selectedHoldName = this.holdTreeData[0].label;
      });
    },
    SearchPatrolCardList: function() {
      this.loadingTableData = true;
      var argdata = {
        search_type: this.formInline.search_type,
        key: this.formInline.key,
        ContainChildren: true,
        HoldID: this.selectHoldId,
        PageIndex: this.pagging.current_page,
        PageSize: this.pagging.pager_size
      };
      
      this.tableData = [];
      Api.SearchPatrolCardList(argdata).then(res => {
        this.loadingTableData = false;
        if(!res)
          return;
        if(res.code === 200 && res.data) {
          this.pagging.records_total = res.total;
          for(var i=0; i<res.data.length; i++) {
            this.tableData.push({
              number: (i + 1),
              patrol_id: res.data[i].patrol_id,
              patrol_sn: res.data[i].patrol_sn,
              patrol_name: res.data[i].patrol_name,
              hold_name: res.data[i].hold_name,
              location: res.data[i].location,
              remark: res.data[i].remark,
              create_time: res.data[i].create_time,
            });
          }
        } else {
          this.$message.error(res.msg);
        }
      }).catch(err => {
        this.$message.error('错了哦，接口出错！' + err);
        this.loadingTableData = false;
      });
    },
    handleNodeClick: function(data) {
      this.selectHoldId = data.id;
      this.selectedHoldName = data.label;
      this.closeLayer();
      this.SearchPatrolCardList();
    },
    openPatrolCardForm: function(id) {
      this.$refs.patrolCardForm.show(id, this.selectHoldId);
    },
    removePatrolCard: function(id) {
      this.$confirm('此操作将删除该巡检点信息, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
         var argdata = {
            patrol_ids: [id]
          };
          Api.RemovePatrolCardInfo(argdata).then(res => {
            if(res.code === 200) {
                  this.$message({
                      message: '已删除！',
                      type: 'success'
                  });
                  this.SearchPatrolCardList();
              } else {
                  this.$message({
                      message: '删除失败！',
                      type: 'warning'
                  });
              }
          });
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // });
      });
    }
  },
  mounted() {
    var h = document.body.clientHeight - 50 - 168;
    var h2 = document.body.clientHeight - 160;
    this.$nextTick(() => {
      const table = this.$refs.getTableInstance;
      if (table) {
        // 使用原生JavaScript设置高度
        table.$el.style.height = h + 'px';
        // 或者使用Vue.set来响应式地更新样式
        // this.$set(table.$el.style, 'height', '300px');
      }
      const tree = this.$refs.getTreeInstance;
      if(tree) {
        tree.$el.style.height = h2 + 'px';
      }
    });

    this.loadHoldTree();
    this.SearchPatrolCardList();

  }
}
</script>